// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthMember {
  flex: 1 1;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
}

.AMDescArea {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.AMDescArea span {
  text-align: center;
  font-size: 1.3rem;
}

.AMDescArea strong {
  font-family: "Jua", sans-serif;
  color: #bc1a21;
  text-align: center;
  font-size: 3.6rem;
}

.AMDImg {
  display: flex;
  padding: 15% 0;
  justify-content: center;
}

.AMInputArea {
  margin-top: 3%;
}

.AMInputTitle {
  font-weight: bold;
  font-size: 1.05rem;
}

.AMInput input {
  padding: 10px 5px;
  margin: 10px 0;
  width: 200px;
  border-radius: 5px;
  border: 1px solid #BBBBBB;
  text-align: center;
}

.AMInput input::placeholder {
  font-size: 0.9rem;
  color: #aaa;
}

.AMInput .AMInputBack {
  min-width: auto;
  width: 60px;
}

.AMInput i {
  padding: 0;
  margin: 0 10px;
}

.AMInputBtn {
  display: flex;
}

.AMInputBtn button {
  padding: 10px 0;
  width: 100%;
  color: white;
  border-radius: 5px;
  background-color: #218E8E;
}

@media (max-width: 768px) {
  /* index */
  .PayStatementTitle {
    top: -70%;
  }
  .PayStatementDesc {
    display: flex;
    margin-top: 3%;
    flex-direction: column;
    text-align: center;
  }
  .DetailPay {
    padding: 8% 5%;
  }
  .DP_TopCnt {
    flex-direction: column;
    padding: 10%;
    align-items: flex-start;
  }
  .DP_TopCnt span {
    font-size: 1.5rem;
  }
  .DP_TopCnt strong {
    font-size: 2.5rem;
  }
  .DP_TopInfo {
    margin-top: 3%;
  }
  .SectionTitle span {
    width: 30%;
    font-size: 1.3rem;
    font-weight: bold;
  }
  .DP_SectionTableArea {
    flex-direction: column;
  }
  .DP_SectionTable:not(:first-child) {
    margin-top: 20px;
  }
  .DP_SectionTable strong {
    font-size: 1.4rem;
    font-weight: bold;
  }
  .DP_MidSection {
    margin-top: 15%;
  }
  .DP_BotDescTitle {
    font-size: 1rem;
    font-weight: bold;
  }
  /* authMember */
  .AMInputArea {
    width: 70%;
  }
  .AMInputTitle {
    font-size: 1.5rem;
  }
  .AMInput input {
    padding: 15px 5px;
    margin: 20px 0;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #BBBBBB;
    text-align: center;
    font-size: 1.4rem;
  }
  .AMInput input::placeholder {
    font-size: 1.4rem;
    color: #aaa;
  }
  .AMInputBtn {
    display: flex;
  }
  .AMInputBtn button {
    padding: 15px 0;
    font-size: 1.4rem;
  }
  /* sendStatePay */
  .SSPLTitleBtn {
    flex-direction: column;
  }
  .SSPLTitleBtn .SSPLTitleBtnInner + .SSPLTitleBtnInner {
    margin-top: 15px;
    justify-content: flex-end;
  }
  .SSPLTitleBtn button {
    flex: 1 1;
    margin-left: 0px;
    padding: 5px 10px;
    font-size: 1.2rem;
    font-weight: bold;
    color: #000;
  }
  .SSPLTitleBtn .SSPLTitleBtnInner + .SSPLTitleBtnInner button {
    flex: none;
    min-width: 20%;
  }
  .SSPLTitleBtn .SSPTitleBtnBar {
    display: flex;
  }
  .SSPLTitleBtn button.BG_blue {
    border: 0;
    background-color: transparent;
  }
  .SSPLTitleBtn button.BG_pink {
    border: 0;
    background-color: transparent;
  }
  .SSPLTitleBtn button.BG_gray {
    border: 0;
    background-color: transparent;
  }
  .SSPLTitleBtn button.BG_puple {
    border: 0;
    background-color: transparent;
  }
  .SSPLTitleBtn button:hover {
    border: 0;
  }
  /* detailPay */
  .DP_TopBackArea button {
    padding: 10px 20px;
  }
  .DP_MidMenu button {
    display: flex;
    padding: 5px 0;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/authForDetailPay/AuthForDetailPay.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;AACJ;;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAER;;AAAI;EACI,kBAAA;EACA,iBAAA;AAGR;;AADI;EACI,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAIR;;AAFI;EACI,aAAA;EACA,cAAA;EACA,uBAAA;AAKR;;AAHI;EACI,cAAA;AAMR;;AAJQ;EACI,iBAAA;EACA,kBAAA;AAOZ;;AAJQ;EACI,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAOZ;;AALQ;EACI,iBAAA;EACA,WAAA;AAQZ;;AANQ;EACI,eAAA;EACA,WAAA;AASZ;;AAPQ;EACI,UAAA;EACA,cAAA;AAUZ;;AARQ;EACI,aAAA;AAWZ;;AATQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAYZ;;AATQ;EACI,UAAA;EACA;IACI,SAAA;EAYd;EAVU;IACI,aAAA;IACA,cAAA;IACA,sBAAA;IACA,kBAAA;EAYd;EATU;IACI,cAAA;EAWd;EATc;IACI,sBAAA;IACA,YAAA;IACA,uBAAA;EAWlB;EATkB;IACI,iBAAA;EAWtB;EATkB;IACI,iBAAA;EAWtB;EATkB;IACI,cAAA;EAWtB;EATkB;IACI,UAAA;IACA,iBAAA;IACA,iBAAA;EAWtB;EATc;IACI,sBAAA;EAWlB;EATkB;IACI,gBAAA;EAWtB;EATkB;IACI,iBAAA;IACA,iBAAA;EAWtB;EATc;IACI,eAAA;EAWlB;EATc;IACI,eAAA;IACA,iBAAA;EAWlB;EATU,eAAA;EACA;IACI,UAAA;EAWd;EATU;IACI,iBAAA;EAWd;EARU;IACI,iBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;IACA,yBAAA;IACA,kBAAA;IACA,iBAAA;EAUd;EARU;IACI,iBAAA;IACA,WAAA;EAUd;EARU;IACI,aAAA;EAUd;EARU;IACI,eAAA;IACA,iBAAA;EAUd;EARU,iBAAA;EACA;IACI,sBAAA;EAUd;EARU;IACI,gBAAA;IACA,yBAAA;EAUd;EARU;IACI,SAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,iBAAA;IACA,WAAA;EAUd;EARU;IACI,UAAA;IACA,cAAA;EAUd;EARU;IACI,aAAA;EAUd;EARU;IACI,SAAA;IACA,6BAAA;EAUd;EARU;IACI,SAAA;IACA,6BAAA;EAUd;EARU;IACI,SAAA;IACA,6BAAA;EAUd;EARU;IACI,SAAA;IACA,6BAAA;EAUd;EARU;IACI,SAAA;EAUd;EARU,cAAA;EAKI;IACI,kBAAA;EAMlB;EAKc;IACI,aAAA;IACA,cAAA;IACA,sBAAA;EAHlB;AACF","sourcesContent":[".AuthMember {\n    flex: 1;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #fff;\n}\n    .AMDescArea {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n    }\n    .AMDescArea span {\n        text-align: center;\n        font-size: 1.3rem;\n    }\n    .AMDescArea strong {\n        font-family: 'Jua', sans-serif;\n        color: #bc1a21;\n        text-align: center;\n        font-size: 3.6rem;\n    }\n    .AMDImg {\n        display: flex;\n        padding: 15% 0;\n        justify-content: center;\n    }\n    .AMInputArea {\n        margin-top: 3%;\n    }\n        .AMInputTitle {\n            font-weight: bold;\n            font-size: 1.05rem;\n        }\n        .AMInput {}\n        .AMInput input {\n            padding: 10px 5px;\n            margin: 10px 0;\n            width: 200px;\n            border-radius: 5px;\n            border: 1px solid #BBBBBB;\n            text-align: center;\n        }\n        .AMInput input::placeholder {\n            font-size: 0.9rem;\n            color: #aaa;\n        }\n        .AMInput .AMInputBack {\n            min-width: auto;\n            width: 60px;\n        }\n        .AMInput i {\n            padding: 0;\n            margin: 0 10px;\n        }\n        .AMInputBtn {\n            display: flex;\n        }\n        .AMInputBtn button {\n            padding: 10px 0;\n            width: 100%;\n            color: white;\n            border-radius: 5px;\n            background-color: #218E8E;\n        }\n\n        @media (max-width: 768px){\n            /* index */\n            .PayStatementTitle {\n                top: -70%;\n            }\n            .PayStatementDesc {\n                display: flex;\n                margin-top: 3%;\n                flex-direction: column;\n                text-align: center;\n            }\n        \n            .DetailPay {\n                padding: 8% 5%;\n            }\n                .DP_TopCnt {  \n                    flex-direction: column;\n                    padding: 10%;\n                    align-items: flex-start;\n                }\n                    .DP_TopCnt span {\n                        font-size: 1.5rem;\n                    }\n                    .DP_TopCnt strong {\n                        font-size: 2.5rem;\n                    }\n                    .DP_TopInfo {\n                        margin-top: 3%;\n                    }\n                    .SectionTitle span {\n                        width: 30%;\n                        font-size: 1.3rem;\n                        font-weight: bold;\n                    }\n                .DP_SectionTableArea {\n                    flex-direction: column;\n                }\n                    .DP_SectionTable:not(:first-child) {\n                        margin-top: 20px;\n                    }\n                    .DP_SectionTable strong {\n                        font-size: 1.4rem;\n                        font-weight: bold;\n                    }\n                .DP_MidSection {\n                    margin-top: 15%;\n                }\n                .DP_BotDescTitle {\n                    font-size: 1rem;\n                    font-weight: bold;\n                }\n            /* authMember */\n            .AMInputArea {\n                width: 70%;\n            }\n            .AMInputTitle {\n                font-size: 1.5rem;\n            }\n            .AMInput {}\n            .AMInput input {\n                padding: 15px 5px;\n                margin: 20px 0;\n                width: 100%;\n                border-radius: 5px;\n                border: 1px solid #BBBBBB;\n                text-align: center;\n                font-size: 1.4rem;\n            }\n            .AMInput input::placeholder {\n                font-size: 1.4rem;\n                color: #aaa;\n            }\n            .AMInputBtn {\n                display: flex;\n            }\n            .AMInputBtn button {\n                padding: 15px 0;\n                font-size: 1.4rem;\n            }\n            /* sendStatePay */\n            .SSPLTitleBtn {\n                flex-direction: column;\n            }\n            .SSPLTitleBtn .SSPLTitleBtnInner+.SSPLTitleBtnInner {\n                margin-top: 15px;\n                justify-content: flex-end;\n            }\n            .SSPLTitleBtn button {\n                flex: 1;\n                margin-left: 0px;\n                padding: 5px 10px;\n                font-size: 1.2rem;\n                font-weight: bold;\n                color: #000;\n            }\n            .SSPLTitleBtn .SSPLTitleBtnInner+.SSPLTitleBtnInner button {\n                flex: none;\n                min-width: 20%;\n            }\n            .SSPLTitleBtn .SSPTitleBtnBar {\n                display: flex;\n            }\n            .SSPLTitleBtn button.BG_blue {\n                border: 0;\n                background-color: transparent;\n            }\n            .SSPLTitleBtn button.BG_pink {\n                border: 0;\n                background-color: transparent;\n            }\n            .SSPLTitleBtn button.BG_gray {\n                border: 0;\n                background-color: transparent;\n            }\n            .SSPLTitleBtn button.BG_puple {\n                border: 0;\n                background-color: transparent;\n            }\n            .SSPLTitleBtn button:hover {\n                border: 0;\n            }\n            /* detailPay */\n            .DP_Top {\n            }\n                .DP_TopBackArea {\n                }\n                .DP_TopBackArea button {\n                    padding: 10px 20px;\n                }\n                .DP_TopName strong{\n                    \n                }\n            .DP_Mid {\n                \n            }\n                .DP_MidMenu {\n                    \n                }\n                .DP_MidMenu button {\n                    display: flex;\n                    padding: 5px 0;\n                    flex-direction: column;\n                }\n                .DP_MidMenu button span {\n                }\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
